import React from 'react'
import limitExhaustSvg from '../../assets/images/limit_exhaust.svg'
import Button from '../buttons/Button'
import { useDispatch } from 'react-redux'
import { resetErrorState } from '../../redux/createImageSlice'
import { useNavigate } from 'react-router-dom'

const LimitError = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleGobackButton = () => {
        dispatch(resetErrorState())
        navigate("/your-past-creations")
        }
    return (
        <div className='h-[calc(100vh-80px)] w-full'>
            <div className='h-full flexCenter flex-col gap-[48px]'>
                <img src={limitExhaustSvg} alt="server busy" className='h-[35%] w-[35%] xl:h-[296px] xl:w-[296px]' />
                <div className='h-[176px] max-w-[876px] text-center flexCenter flex-col gap-[24px]'>
                    <h1 className='text-[#313945] font-helveticaDisp-Bold text-[40px] font-[700] leading-[48px] tracking-[-0.02em]'>You've reached today's image limit</h1>
                    <p className='text-[23px] text-secondary'>You've generated 100 images today! Your creative engine needs a recharge! Come back tomorrow when your image limit resets.</p>
                    <Button onClick={handleGobackButton} label='View Past Creations' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[48px] " />
                </div>

            </div>
        </div>
    )
}

export default LimitError